/** You › Advanced: standing automation grants and per-project autonomy. */
import { Link, useSearch } from '@tanstack/react-router'
import { Automation } from '../../components/Grants.js'
import { LoopPicker } from '../../components/ProjectSettings.js'
import { HubBudget, MachineReportStats, TabRequestMeter } from '../../components/RequestCost.js' // burst-guard
import { projectHref } from '../../lib/ia.js' // ia-shell
import { useMachines, useProjects } from '../../lib/queries.js'
import { Section } from './shared.js'

export function AdvancedSection() {
  const search = useSearch({ strict: false }) as { grantMachines?: string; grantProjects?: string }
  const split = (v?: string) => (v ? v.split(',').filter(Boolean) : undefined)
  const gm = split(search.grantMachines)
  const gp = split(search.grantProjects)
  return (
    <>
      <Section id="automation" title="Automation">
        <Automation
          prefill={{ ...(gm ? { machineIds: gm } : {}), ...(gp ? { projectIds: gp } : {}) }}
        />
      </Section>
      <ProjectPolicies />
      <RequestCost />
    </>
  )
}

/** Loop profile + autonomy level per project (full per-action editor: Project › Settings). */
function ProjectPolicies() {
  const projects = useProjects()
  const list = projects.data ?? []
  if (!list.length) return null
  return (
    <Section id="policies" title="Project autonomy">
      <ul className="m-0 grid list-none gap-4 p-0 st-pad">
        {list.map((p) => (
          <li key={p.id} className="grid gap-2">
            <Link
              to={projectHref(p.id, 'settings')}
              className="text-[15px] font-medium text-text-1"
            >
              {p.name}
            </Link>
            <LoopPicker project={p} />
          </li>
        ))}
      </ul>
    </Section>
  )
}

/** burst-guard: what keeping these screens fresh costs (this tab, each machine, the account today). */
function RequestCost() {
  const machines = useMachines()
  return (
    <Section id="request-cost" title="Request cost">
      <p className="st-lede">
        Requests this tab and your machines make to the hub, and the account’s daily budget.
      </p>
      <div className="st-pad flex flex-wrap items-start gap-2">
        <TabRequestMeter />
        <HubBudget />
        {(machines.data ?? []).map((m) =>
          m.reportStats ? (
            <MachineReportStats key={m.id} stats={m.reportStats} name={m.name} />
          ) : null,
        )}
      </div>
    </Section>
  )
}
